import styled from 'styled-components';

export const Field = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[5]};
`;

export const Label = styled.label`
  display: block;
  font-family: ${({ theme }) => theme.typography.fontFamilies.mono};
  font-size: ${({ theme }) => theme.typography.fontSizes.monoSm};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.ink[3]};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  background: ${({ theme }) => theme.surface.bg};
  border: 1px solid ${({ theme }) => theme.line.line};
  border-radius: ${({ theme }) => theme.radii.sm};
  font-family: ${({ theme }) => theme.typography.fontFamilies.sans};
  font-size: ${({ theme }) => theme.typography.fontSizes.bodySm};
  color: ${({ theme }) => theme.ink[1]};
  transition:
    border-color ${({ theme }) => theme.motion.duration.fast} ${({ theme }) => theme.motion.easing.out},
    background ${({ theme }) => theme.motion.duration.fast} ${({ theme }) => theme.motion.easing.out};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.ink[1]};
    background: ${({ theme }) => theme.surface.elev};
  }
  &::placeholder {
    color: ${({ theme }) => theme.ink[4]};
  }
`;

export const Textarea = styled.textarea`
  display: block;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  background: ${({ theme }) => theme.surface.bg};
  border: 1px solid ${({ theme }) => theme.line.line};
  border-radius: ${({ theme }) => theme.radii.sm};
  font-family: ${({ theme }) => theme.typography.fontFamilies.sans};
  font-size: ${({ theme }) => theme.typography.fontSizes.bodySm};
  color: ${({ theme }) => theme.ink[1]};
  resize: vertical;
  min-height: 88px;
  line-height: ${({ theme }) => theme.typography.lineHeights.body};
  transition:
    border-color ${({ theme }) => theme.motion.duration.fast} ${({ theme }) => theme.motion.easing.out},
    background ${({ theme }) => theme.motion.duration.fast} ${({ theme }) => theme.motion.easing.out};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.ink[1]};
    background: ${({ theme }) => theme.surface.elev};
  }
  &::placeholder {
    color: ${({ theme }) => theme.ink[4]};
  }
`;

export const FieldHint = styled.p<{ $error?: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSizes.uiSm};
  color: ${({ theme, $error }) => ($error ? theme.tone.solar.base : theme.ink[3])};
  margin-top: ${({ theme }) => theme.spacing[2]};
  line-height: ${({ theme }) => theme.typography.lineHeights.relaxed};
`;
